import Image from '@components/Image';
import RawHtml from '@components/RawHtml';
import clsx from 'clsx';
import Link from 'next/link';

import { WagtailImage, WagtailPage } from '@/types';
import { removeBaseUrl } from '@/utils/url';

type Card = {
  button_page: WagtailPage | null;
  button_url: string | null;
  buttonLink?: boolean;
  text: string;
  title: string;
  image: WagtailImage | null;
};

type Props = {
  roundImage?: boolean;
  title?: string;
  text?: string;
  bottomtext?: string;
  background: string;
  cards: Card[];
};

function Cards(props: Props) {
  const { cards, title, text, background, bottomtext, roundImage } = props;

  return (
    <section className={clsx('cards', background, roundImage ? 'roundImg' : '')}>
      <div className='cards__background'>
        <div className='container'>
          {title || text ? (
            <div className='cards__header'>
              {title ? <h2 className='cards__title'>{title}</h2> : null}
              {text ? <RawHtml html={text} /> : null}
            </div>
          ) : null}
          <div className='cards__wrapper'>
            {cards.map(card => (
              <div className='card' key={card.title}>
                {card.image ? (
                  <div className='card__iconwrapper'>
                    <Image
                      image={card.image}
                      className='card__icon'
                      spec={roundImage ? 'fill-320x320' : 'max-224x224'}
                      width={roundImage ? 320 : 224}
                      height={roundImage ? 320 : 224}
                    />
                  </div>
                ) : null}
                <h2 className='card__title'>{card.title}</h2>
                <RawHtml className='card__text' html={card.text} />
                {card.button_page || card.button_url ? (
                  <Link
                    href={
                      card.button_page
                        ? removeBaseUrl(card.button_page.full_url)
                        : (card.button_url ?? '')
                    }
                    passHref
                    className={clsx(
                      card.buttonLink ? 'button button--primary card__link' : 'card__link',
                    )}
                  >
                    Zur Seite
                  </Link>
                ) : null}
              </div>
            ))}
          </div>
          {bottomtext ? <RawHtml className='cards__footer' html={bottomtext} /> : null}
        </div>
      </div>
    </section>
  );
}

export default Cards;
